<div class="container-fluid modal">
    <div class="modal-content confirm-modal" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
        <div class="confirm-modal-header">
            <h5 id="confirm-modal-title" class="confirm-modal-title m-0">
                {{ titleKey | translate }}
            </h5>
            <button type="button" class="confirm-modal-close" (click)="cancel.emit()"
                [attr.aria-label]="cancelText | translate">
                <svg aria-hidden="true" viewBox="0 0 24 24" width="14" height="14">
                    <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                </svg>
            </button>
        </div>

        <div class="confirm-modal-body">
            <p class="confirm-modal-message m-0">
                {{ question | translate }}
            </p>

            <div class="confirm-modal-actions">
                <button type="button" class="confirm-modal-button confirm-modal-button-secondary" (click)="cancel.emit()">
                    {{ cancelText | translate }}
                </button>
                <button type="button" class="confirm-modal-button confirm-modal-button-primary" (click)="confirm.emit()">
                    {{ confirmText | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
